import { typographyBase } from 'src/theme/typography';
import { palette } from 'theme/palette';

const SELECTED_HOVER_COLOR =
  'color-mix(in srgb, var(--DataGrid-t-color-background-base), var(--DataGrid-t-color-interactive-selected) calc(calc(var(--DataGrid-t-color-interactive-selected-opacity) + var(--DataGrid-t-color-interactive-hover-opacity)) * 100%))';

const createPinnedCellStyleOverride = ({
  visible,
  backgroundColor = palette.background.default,
}: {
  visible: boolean;
  backgroundColor?: string;
}) => ({
  backgroundColor: `${visible ? backgroundColor : 'transparent'} !important`,
  borderLeft: 'none !important',
  '& > *': {
    opacity: visible ? 1 : 0,
  },

  '&:empty': {
    backgroundColor: 'transparent !important',
  },
});

const gridRowHover = {
  backgroundColor: palette.background.default,
  '& .MuiDataGrid-cell': {
    '&--pinnedRight': createPinnedCellStyleOverride({ visible: true }),

    '&--pinnedLeft': {
      backgroundColor: `inherit !important`,
    },
  },
};

const gridRowSelected = {
  '&:hover': {
    backgroundColor: SELECTED_HOVER_COLOR,
    '& .MuiDataGrid-cell': {
      '&--pinnedRight': createPinnedCellStyleOverride({
        visible: true,
        backgroundColor: SELECTED_HOVER_COLOR,
      }),
      '&--pinnedLeft': {
        backgroundColor: `inherit !important`,
      },
    },
  },

  '& .MuiDataGrid-cell': {
    '&--pinnedRight': createPinnedCellStyleOverride({ visible: false }),

    '&--pinnedLeft': {
      backgroundColor: `inherit !important`,
    },
  },
};

export const muiDataGridRowStyleOverride = {
  height: '3.25rem',
  background: palette.background.paper,
  '&--firstVisible': {
    '& .MuiDataGrid-scrollbarFiller.MuiDataGrid-scrollbarFiller--borderTop': {
      borderTop: 'none',
    },
  },

  '&:hover': gridRowHover,
  '&.Mui-selected': gridRowSelected,

  '& .MuiDataGrid-cell': {
    ...typographyBase.text1,
    display: 'flex',
    alignItems: 'center',

    '&:focus-within': {
      outline: 'none !important',
    },

    '&:focus': {
      outline: 'none',
    },

    '&--pinnedRight': createPinnedCellStyleOverride({ visible: false }),
    '&--pinnedLeft': {
      backgroundColor: 'inherit !important',
      borderRight: 'none',
    },
  },
};
